import { type JSX } from '@builder.io/qwik';
import { Slot, component$ } from '@builder.io/qwik';

interface FigureWrapperProps {
  captionClass: string;
  captionAndCredit: string;
}

export default component$<FigureWrapperProps>(
  ({ captionClass, captionAndCredit }): JSX.Element => (
    <figure>
      <Slot />
      <figcaption
        class={captionClass}
        dangerouslySetInnerHTML={captionAndCredit}
      />
    </figure>
  )
);
